export const initialState = {
  filters: {},
  staticPage: {},
  resources: [],
  loading: false,
  homeBannerImage: {}
};
